import { render, staticRenderFns } from "./MinistryHome.vue?vue&type=template&id=48bd687c&"
import script from "./MinistryHome.vue?vue&type=script&lang=js&"
export * from "./MinistryHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports